// import {Platform} from "react-native";
//
// module.exports = Platform.OS === 'android' ? require("react-native-firebase") : null;


/**
 * @providesModule RNRestart
 */

'use strict';


const AddToHomeScreen  = require("./../../tools/addToHome/AddToHomeScreen").default;

export default AddToHomeScreen;
